import jQuery from "jquery";
import _ from "underscore";

const Dialog = {};
Dialog['ModalPrompt'] = {};

Dialog.addButtons = (dialog, buttons) => {
  const footerDom = jQuery('<div class="modal-footer"></div>');

  for (const button in buttons) {
    let btnClass = (button === 'OK' || button === 'Done') ? 'btn-primary' : null;

    // apply the primary style to the non-cancel button, as many dialogs don't just use 'OK', 'Cancel'
    if (!btnClass) {
      if (buttons['Cancel'] && button !== 'Cancel') {
        btnClass = 'btn-primary';
      }
    }

    const buttonDom = jQuery(`<button type="button" class="btn ${btnClass || 'btn-secondary'}">${button}</button>`);

    // attach listener
    if (buttons[button]) {
      buttonDom.on('click', buttons[button]);
    }

    footerDom.append(buttonDom);
  }

  dialog.find('.modal-content').append(footerDom);
};

Dialog.ModalPrompt.setSelector = selector => {
  Dialog.ModalPrompt.SELECTOR = selector;
  Dialog.ModalPrompt.LABEL_ID = "modal_prompt_label";
  Dialog.ModalPrompt.MESSAGE_ID = "modal_prompt_message";
  Dialog.ModalPrompt.STATUS_ID = "modal_prompt_status";
  Dialog.ModalPrompt.LABEL_SELECTOR = `${Dialog.ModalPrompt.SELECTOR} #${Dialog.ModalPrompt.LABEL_ID}`;
  Dialog.ModalPrompt.MESSAGE_SELECTOR = `${Dialog.ModalPrompt.SELECTOR} #${Dialog.ModalPrompt.MESSAGE_ID}`;
  Dialog.ModalPrompt.STATUS_SELECTOR = `${Dialog.ModalPrompt.SELECTOR} #${Dialog.ModalPrompt.STATUS_ID}`;
};

Dialog.ModalPrompt.setSelector("#modal_prompt_dialog");

Dialog.ModalPrompt.show = dialogOptions => {
  const modalDialog = jQuery(Dialog.ModalPrompt.SELECTOR);
  // Check if modal is fading out but is not yet hidden. It can happen when opening new dialog from another.
  // In that case wait until it's completely hidden and only then show the new modal (prevents backdrop overlay issues)
  if (modalDialog.data('hiding') === true) {
    modalDialog.data('pendingShow', true);
    const showModalIfStillNotHidden = setTimeout(() => {
      Dialog.ModalPrompt._showModal(dialogOptions);
    }, 750);
    modalDialog.one('hidden.bs.modal', () => {
      clearTimeout(showModalIfStillNotHidden);
      Dialog.ModalPrompt._showModal(dialogOptions);
    });
  } else {
    Dialog.ModalPrompt._showModal(dialogOptions);
  }
};

Dialog.ModalPrompt._showModal = dialogOptions => {
  const modalDialog = jQuery(Dialog.ModalPrompt.SELECTOR);
  modalDialog.data('pendingShow', false);
  modalDialog.data('hiding', false);

  if (jQuery(Dialog.ModalPrompt.LABEL_SELECTOR).length === 0) {
    jQuery(Dialog.ModalPrompt.SELECTOR).find('.modal-body').append(
      `<div id="${Dialog.ModalPrompt.LABEL_ID}" class="dialog--label"></div>
       <textarea id="${Dialog.ModalPrompt.MESSAGE_ID}" rows="6" cols="40" class="form-control"></textarea>
       <div id="${Dialog.ModalPrompt.STATUS_ID}">&nbsp;</div>`);

    if (dialogOptions.maxCharCount) {
      const countCheck = () => {
        Dialog.ModalPrompt.validateMaxCharCount(dialogOptions.maxCharCount);
      };

      jQuery(Dialog.ModalPrompt.SELECTOR).find('textarea').on({
        keyup: countCheck,
        paste() {
          // defer the check to allow the paste to insert text
          _.defer(countCheck);
        }
      });
    }
  }

  // set title and buttons
  modalDialog.find('.modal-title').html(dialogOptions['title']);

  // clear old buttons
  modalDialog.find('.modal-footer').remove();

  if (dialogOptions['buttons']) {
    Dialog.addButtons(modalDialog, dialogOptions['buttons']);
  }

  Dialog.ModalPrompt._afterClose = dialogOptions.afterClose;

  modalDialog.off('hide.bs.modal', Dialog.ModalPrompt._closeCallback).on('hide.bs.modal', Dialog.ModalPrompt._closeCallback);
  modalDialog.off('hidden.bs.modal', Dialog.ModalPrompt._hiddenCallback).on('hidden.bs.modal', Dialog.ModalPrompt._hiddenCallback);

  modalDialog.modal();
};

Dialog.ModalPrompt._afterClose = null;
Dialog.ModalPrompt._closeCallback = function() {
  Dialog.ModalPrompt.clearStatus();
  // flag tracking the fading out of the modal (the interval between hide.bs.modal and hidden.bs.modal events)
  jQuery(Dialog.ModalPrompt.SELECTOR).data('hiding', true);

  if (typeof Dialog.ModalPrompt._afterClose === "function") {
    Dialog.ModalPrompt._afterClose.apply(this);
  }
};

Dialog.ModalPrompt._hiddenCallback = () => {
  const modalDialog = jQuery(Dialog.ModalPrompt.SELECTOR);
  modalDialog.data('hiding', false);
  if (modalDialog.data('pendingShow') !== true) {
    // restore message box in case there was a call to hideMessage()
    jQuery(Dialog.ModalPrompt.MESSAGE_SELECTOR).show();
  }
};

Dialog.ModalPrompt.clearStatus = () => {
  Dialog.ModalPrompt.setStatus('&nbsp;');
};

Dialog.ModalPrompt.setStatus = (message, error) => {
  jQuery(Dialog.ModalPrompt.STATUS_SELECTOR).html(message).css('color', error ? '#990000' : 'black');
};

Dialog.ModalPrompt.getMessage = () => jQuery(Dialog.ModalPrompt.MESSAGE_SELECTOR).val();

Dialog.ModalPrompt.setMessage = value => {
  jQuery(Dialog.ModalPrompt.MESSAGE_SELECTOR).val(value);
};

Dialog.ModalPrompt.hideMessage = () => {
  jQuery(Dialog.ModalPrompt.MESSAGE_SELECTOR).hide();
};

Dialog.ModalPrompt.setLabel = value => {
  jQuery(Dialog.ModalPrompt.LABEL_SELECTOR).html(value);
};

Dialog.ModalPrompt.enableButtons = () => {
  jQuery(Dialog.ModalPrompt.SELECTOR).parent().find("button").removeAttr('disabled');
};

Dialog.ModalPrompt.disableButtons = () => {
  jQuery(Dialog.ModalPrompt.SELECTOR).parent().find("button").attr('disabled', 'disabled');
};

Dialog.ModalPrompt.disablePrimaryButton = () => {
  jQuery(Dialog.ModalPrompt.SELECTOR).find(".btn-primary").attr('disabled', 'disabled');
};

Dialog.ModalPrompt.close = () => {
  jQuery(Dialog.ModalPrompt.SELECTOR).modal('hide');
};

Dialog.ModalPrompt.validateMaxCharCount = maxCharCount => {
  const charsRemaining = maxCharCount - Dialog.ModalPrompt.getCharCount();
  if (charsRemaining < 0) {
    Dialog.ModalPrompt.setStatus(`${-1 * charsRemaining} chars above limit`, true);
    Dialog.ModalPrompt.disablePrimaryButton();
  } else if (charsRemaining <= 30) {
    Dialog.ModalPrompt.setStatus(`${charsRemaining} chars remaining`);
    Dialog.ModalPrompt.enableButtons();
  } else {
    Dialog.ModalPrompt.clearStatus();
    Dialog.ModalPrompt.enableButtons();
  }
};

Dialog.ModalPrompt.getCharCount = () => jQuery(Dialog.ModalPrompt.SELECTOR).find('textarea').val().length;

export default Dialog;
